import {
  APPLIED_FILTER_OPERATOR_EQUALS,
  APPLIED_FILTER_OPERATOR_NOT_EQUALS,
  APPLIED_FILTER_OPERATOR_CONTAINS,
  APPLIED_FILTER_OPERATOR_NOT_CONTAINS,
  APPLIED_FILTER_OPERATOR_STARTS_WITH,
  APPLIED_FILTER_OPERATOR_NOT_STARTS_WITH,
  APPLIED_FILTER_OPERATOR_ENDS_WITH,
  APPLIED_FILTER_OPERATOR_NOT_ENDS_WITH,
  APPLIED_FILTER_OPERATOR_SHORT_EQUALS,
  APPLIED_FILTER_OPERATOR_SHORT_NOT_EQUALS,
  APPLIED_FILTER_OPERATOR_GREATER_THAN,
  APPLIED_FILTER_OPERATOR_GREATER_THAN_OR_EQUAL_TO,
  APPLIED_FILTER_OPERATOR_LESS_THAN,
  APPLIED_FILTER_OPERATOR_LESS_THAN_OR_EQUAL_TO,
  APPLIED_FILTER_OPERATOR_CURRENT_DATE,
  APPLIED_FILTER_OPERATOR_WITHIN_PAST_X_DAYS,
  APPLIED_FILTER_OPERATOR_WITHIN_NEXT_X_DAYS,
  APPLIED_FILTER_OPERATOR_BEFORE_X_DAYS,
  APPLIED_FILTER_OPERATOR_AFTER_X_DAYS,
  APPLIED_FILTER_OPERATOR_ON_OR_AFTER,
  APPLIED_FILTER_OPERATOR_ON_OR_BEFORE,
  APPLIED_FILTER_OPERATOR_EQUALS_TRUE,
  APPLIED_FILTER_OPERATOR_EQUALS_FALSE,
  APPLIED_FILTER_OPERATOR_IS_BLANK,
  APPLIED_FILTER_OPERATOR_IS_NOT_BLANK,
  APPLIED_FILTER_OPERATOR_TIME_AT_OR_AFTER,
  APPLIED_FILTER_OPERATOR_TIME_AT_OR_BEFORE,
} from '../constants/applied-filter-operator';

import {
  OPERATOR_TYPE_INCLUDES,
  OPERATOR_TYPE_DOES_NOT_INCLUDE,
  OPERATOR_TYPE_CONTAINS,
  OPERATOR_TYPE_DOES_NOT_CONTAIN,
  OPERATOR_TYPE_VALUE_ARE_EMPTY,
  OPERATOR_TYPE_STARTS_WITH,
  OPERATOR_TYPE_DOES_NOT_START_WITH,
  OPERATOR_TYPE_UNDEFINED,
  OPERATOR_TYPE_IS_BLANK,
  OPERATOR_TYPE_IS_NOT_BLANK,
  OPERATOR_TYPE_EQUALS,
  OPERATOR_TYPE_NOT_EQUALS,
  OPERATOR_TYPE_ENDS_WITH,
  OPERATOR_TYPE_DOES_NOT_END_WITH,
  OPERATOR_TYPE_SHORT_EQUALS,
  OPERATOR_TYPE_SHORT_NOT_EQUALS,
  OPERATOR_TYPE_GREATER_THAN,
  OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_LESS_THAN,
  OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_CURRENT_DATE,
  OPERATOR_TYPE_WITHIN_PAST_X_DAYS,
  OPERATOR_TYPE_WITHIN_NEXT_X_DAYS,
  OPERATOR_TYPE_BEFORE_X_DAYS,
  OPERATOR_TYPE_AFTER_X_DAYS,
  OPERATOR_TYPE_ON_OR_AFTER,
  OPERATOR_TYPE_ON_OR_BEFORE,
  OPERATOR_TYPE_VALUE_EQUALS_TRUE,
  OPERATOR_TYPE_VALUE_EQUALS_FALSE,
  OPERATOR_TYPE_TIME_AT_OR_AFTER,
  OPERATOR_TYPE_TIME_AT_OR_BEFORE,
} from '../constants/filter-operator-type';

const operatorTypeToOperatorPropMap = {
  [OPERATOR_TYPE_CONTAINS]: APPLIED_FILTER_OPERATOR_CONTAINS,
  [OPERATOR_TYPE_DOES_NOT_CONTAIN]: APPLIED_FILTER_OPERATOR_NOT_CONTAINS,
  [OPERATOR_TYPE_STARTS_WITH]: APPLIED_FILTER_OPERATOR_STARTS_WITH,
  [OPERATOR_TYPE_DOES_NOT_START_WITH]: APPLIED_FILTER_OPERATOR_NOT_STARTS_WITH,
  [OPERATOR_TYPE_IS_BLANK]: APPLIED_FILTER_OPERATOR_IS_BLANK,
  [OPERATOR_TYPE_IS_NOT_BLANK]: APPLIED_FILTER_OPERATOR_IS_NOT_BLANK,
  [OPERATOR_TYPE_EQUALS]: APPLIED_FILTER_OPERATOR_EQUALS,
  [OPERATOR_TYPE_NOT_EQUALS]: APPLIED_FILTER_OPERATOR_NOT_EQUALS,
  [OPERATOR_TYPE_ENDS_WITH]: APPLIED_FILTER_OPERATOR_ENDS_WITH,
  [OPERATOR_TYPE_DOES_NOT_END_WITH]: APPLIED_FILTER_OPERATOR_NOT_ENDS_WITH,
  [OPERATOR_TYPE_SHORT_EQUALS]: APPLIED_FILTER_OPERATOR_SHORT_EQUALS,
  [OPERATOR_TYPE_SHORT_NOT_EQUALS]: APPLIED_FILTER_OPERATOR_SHORT_NOT_EQUALS,
  [OPERATOR_TYPE_GREATER_THAN]: APPLIED_FILTER_OPERATOR_GREATER_THAN,
  [OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO]: APPLIED_FILTER_OPERATOR_GREATER_THAN_OR_EQUAL_TO,
  [OPERATOR_TYPE_LESS_THAN]: APPLIED_FILTER_OPERATOR_LESS_THAN,
  [OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO]: APPLIED_FILTER_OPERATOR_LESS_THAN_OR_EQUAL_TO,
  [OPERATOR_TYPE_CURRENT_DATE]: APPLIED_FILTER_OPERATOR_CURRENT_DATE,
  [OPERATOR_TYPE_WITHIN_PAST_X_DAYS]: APPLIED_FILTER_OPERATOR_WITHIN_PAST_X_DAYS,
  [OPERATOR_TYPE_WITHIN_NEXT_X_DAYS]: APPLIED_FILTER_OPERATOR_WITHIN_NEXT_X_DAYS,
  [OPERATOR_TYPE_BEFORE_X_DAYS]: APPLIED_FILTER_OPERATOR_BEFORE_X_DAYS,
  [OPERATOR_TYPE_AFTER_X_DAYS]: APPLIED_FILTER_OPERATOR_AFTER_X_DAYS,
  [OPERATOR_TYPE_ON_OR_AFTER]: APPLIED_FILTER_OPERATOR_ON_OR_AFTER,
  [OPERATOR_TYPE_ON_OR_BEFORE]: APPLIED_FILTER_OPERATOR_ON_OR_BEFORE,
  [OPERATOR_TYPE_VALUE_EQUALS_TRUE]: APPLIED_FILTER_OPERATOR_EQUALS_TRUE,
  [OPERATOR_TYPE_VALUE_EQUALS_FALSE]: APPLIED_FILTER_OPERATOR_EQUALS_FALSE,
  [OPERATOR_TYPE_TIME_AT_OR_AFTER]: APPLIED_FILTER_OPERATOR_TIME_AT_OR_AFTER,
  [OPERATOR_TYPE_TIME_AT_OR_BEFORE]: APPLIED_FILTER_OPERATOR_TIME_AT_OR_BEFORE,
};

const operatorPropFromOperatorType = (operator) => {
  if (!operatorTypeToOperatorPropMap[operator]) {
    return OPERATOR_TYPE_UNDEFINED;
  }
  return operatorTypeToOperatorPropMap[operator];
};

export const appliedFilterPropsFromOperatorType = (operator) => {
  const isIn = ![OPERATOR_TYPE_INCLUDES, OPERATOR_TYPE_DOES_NOT_INCLUDE].includes(operator)
    ? undefined
    : operator === OPERATOR_TYPE_INCLUDES;
  const isNull = ![OPERATOR_TYPE_VALUE_ARE_EMPTY].includes(operator) ? undefined : operator === OPERATOR_TYPE_VALUE_ARE_EMPTY; // add the ARE_NOT_EMPTY
  const operatorProp = operatorPropFromOperatorType(operator);
  return {
    operator: operatorProp === OPERATOR_TYPE_UNDEFINED ? undefined : operatorProp,
    isIn,
    isNull,
  };
};
